<template>
  <div class="menu-wrapper">
    <ul class="menu_ul" v-if="![10,12,14,15].includes(roleId)">
      <li
        @click="settings('profile')"
        :class="{active_page:active_tab=='profile'}"
        v-if="roleId !== 13"
      >
        <img class="menu_icon" src="/static/images/icons/profile_icon.svg" alt="profile-icon"/>
        <span>Profile</span>
      </li>
      <li
        :class="{active_page:(['notifications','dashboard','preferences','team','billing','services'].includes[active_tab])}"
        v-if="roleId !== 4"
      >
        <img class="menu_icon" src="/static/images/icons/settings_icon.svg" alt="settings-icon"/>
        <span>Account Settings</span>
      </li>
      <li class="sub_menu_wrapper" v-if="roleId !== 4 && roleId !== 13">
        <ul class="sub_menu">
          <li @click="settings('notifications')" :class="{active_page:active_tab=='notifications'}">
            <span>Notifications</span>
          </li>
          <li
            v-if="isDashboardCustomizable && ![4,11].includes(roleId)"
            @click="settings('dashboard')"
            :class="{active_page:active_tab=='dashboard'}"
          ><span>Dashboard</span>
          </li>
          <li @click="settings('preferences')" :class="{active_page:active_tab=='preferences'}">
            <span>Preferences</span>
          </li>
          <li
            v-if="[1,5,9].includes(roleId)"
            @click="settings('team')"
            :class="{active_page:active_tab=='team'}"
          >
            <span>Team</span>
          </li>
          <li v-if="[1,5,9].includes(roleId)" @click="settings('services')" :class="{active_page:active_tab=='services'}">
            <span>Services</span>
          </li>
          <li  v-if="!isREP && [1,5].includes(roleId)" @click="settings('billing')" :class="{active_page:active_tab=='billing'}">
            <span>Billing</span>
          </li>
        </ul>
      </li>
      <li class="sub_menu_wrapper" v-if="roleId == 13 && accountTypeId === 2">
        <ul class="sub_menu">
          <li
            @click="settings('team')"
            :class="{active_page:active_tab=='team'}"
          >
            <span>Team</span>
          </li>
        </ul>
      </li>
      <li
        @click="settings('tour')"
        :class="{active_page:active_tab=='tour'}"
        v-if="![4,7,13].includes(roleId)"
      >
        <img class="menu_icon" src="/static/images/icons/virtual_tour_icon.svg" alt="virtual-icon"/>
        <span>Virtual Tour</span>
      </li>
      <!-- <li class="nav-item dl-inf col-sm-12">
      <img src="/static/images/icons/phone_icon.svg" alt="phone-icon"/>
      <a class="nav-link">Customer Support</a>
    </li>
    <li class="nav-item dl-inf col-sm-12">
      <img src="/static/images/icons/help_icon.svg" alt="help-icon"/>
      <a class="nav-link">Help</a>
      </li>-->
      <li @click="settings('logout')" :class="{active_page:active_tab=='logout'}">
        <img class="menu_icon" src="/static/images/icons/logout_icon.svg" alt="logout-icon"/>
        <span>Log out</span>
      </li>
    </ul>
  </div>
</template>
<script>

export default {
  props: ['activeTab', 'roleId', 'isDashboardCustomizable'],
  data() {
    return {
      active_tab: '',
      isREP: JSON.parse(localStorage.getItem('userData')).account_type_id === 2 || JSON.parse(localStorage.getItem('userData')).account_type_id === 4,
      accountTypeId: JSON.parse(localStorage.getItem('userData')).account_type_id,
      dashboardCustomizable: null,
    };
  },
  watch: {
    activeTab() {
      this.active_tab = this.activeTab;
    },
    isDashboardCustomizable() {
      this.dashboardCustomizable = this.isDashboardCustomizable;
    },
  },
  methods: {
    settings(data) {
      this.$emit('menuClicked', data);
    },
  },
};
</script>
<style lang="scss" scoped>
.active_page {
  background-color: #d3d6d9;
  font-weight: $font-weight-medium;
}
.menu-wrapper {
  color: $primary;
  font-family: Roboto;
  font-style: normal;
  font-weight: $font-weight-normal;
  font-size: $font-16;
  line-height: 19px;
}
.menu_ul {
  list-style: none;
  padding: 0px;
}
.menu_ul {
  & > li {
    padding: 8px;
    cursor: pointer;  
  }
}
.sub_menu {
  list-style: none;
  padding: 0px;
}
.sub_menu > li {
  padding: 8px 8px 10px 30%;
  cursor: pointer;
  margin: 2px 0px 2px 0px;
}
.sub_menu_wrapper {
  padding: 5px 0 8px !important;
  cursor: unset !important;
}
.menu_icon {
  margin: 0px 10px;
  vertical-align: top;
}
</style>
